module.exports = __webpack_public_path__ + "img/inv.2d19ebc4.svg";